import { render, staticRenderFns } from "./GST.vue?vue&type=template&id=5104378e&"
import script from "./GST.vue?vue&type=script&lang=js&"
export * from "./GST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports